import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { UnitofmeasurementcultureInsertService } from '../../service/unitofmeasurementculture-insert/unitofmeasurementculture-insert.service';

@Component({
	selector: 'app-unitofmeasurementculture-insert',
	templateUrl: './unitofmeasurementculture-insert.component.html',
	providers: [
		UnitofmeasurementcultureInsertService,
		HttpModule
	]
})
export class UnitofmeasurementcultureInsertComponent implements OnInit {

	private token;
	public permissoes: any[] = [];
	unit: FormGroup;
	Nome: string = "";
	Sigla: string = "";
	statusUnit: boolean;

	constructor(fb: FormBuilder, private unitofmeasurementcultureInsertService: UnitofmeasurementcultureInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.unit = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Sigla': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addUnit(value: any) {
		console.log('value: ' + value);

		this.unitofmeasurementcultureInsertService.insertUnit(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Unidade de Medida Cultura cadastrada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/unidade-medida-cultura');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/unidade-medida-cultura');
	}

}



// WEBPACK FOOTER //
// ./src/app/unitofmeasurementculture/component/unitofmeasurementculture-insert/unitofmeasurementculture-insert.component.ts